import React, {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import "./style.css";
import {changeXuan} from "../../store/pageSlice";
import {useDispatch} from "react-redux";

export const Moment = () => {
  const { t, i18n } = useTranslation();
  const [detail1, setDetail1] = useState(false)
  const [detail2, setDetail2] = useState(false)
  const dispatch = useDispatch();
  useEffect(() => {
    const div = document.documentElement.querySelector('.div');
    const height=document.documentElement.clientHeight+'px';
    // div.style.height=height
    //   if(document.documentElement.clientHeight<=1700){
    //       div.style.height='1700px'
    //   }
    // div.style.background='black'
    dispatch(changeXuan(5))

  }, [])
  return (
    <div className="moment">
      <div className="div">
        <a href={"https://vr.justeasy.cn/view/s179239m1247ld34-1792555083.html"} className=" weixuan"
           style={{color: 'black',top:'50%'}}>
          
          <button>{t("亮点请点击")}</button>
        </a>
        {/* <div>
          <a href={"https://m.alltuu.com/album/4054401779/?menu=live"} className="text-wrapper-2"
             style={{color: 'white', top: '1258px'}}>
            {t("活动现场花絮请点击")}
          </a>
        </div> */}


        {/* <img
            className=""
            alt="Img"
            src={t("is_en") == 1 ? "/img/2026-9/qidai-en.png" : "/img/2026-9/qidai.png"}
            style={t("is_en") == 1 ? {width: '60%'} : {width: '40%'}}
        /> */}
        {/*<div style={{color: 'white', position: 'absolute', left: 60, top: 320,width:'146px'}}>*/}
        {/*  {*/}
        {/*    detail1 ? <img*/}
        {/*        className="icon-fadeIn"*/}
        {/*        alt="Img"*/}
        {/*        src="/img/2026/icon1.png"*/}
        {/*        onClick={() => {*/}
        {/*          setDetail1(!detail1)*/}
        {/*        }}*/}
        {/*    />:null*/}
        {/*  }*/}

        {/*  <img*/}
        {/*      className="dian-sparkle"*/}
        {/*      style={{position: 'absolute', right: -10, top: 0}}*/}
        {/*      alt="Img"*/}
        {/*      src="/img/2026/dian.png"*/}
        {/*      onClick={() => {*/}
        {/*        setDetail1(!detail1)*/}
        {/*      }}*/}
        {/*  />*/}
        {/*</div>*/}

        {/*<div style={{color: 'white', position: 'absolute', left: 80, top: 660,width:'173px'}}>*/}
        {/*  {*/}
        {/*    detail2 ? <img*/}
        {/*        className="icon-slideIn"*/}
        {/*        alt="Img"*/}
        {/*        src="/img/2026/icon2.png"*/}
        {/*        onClick={() => {*/}
        {/*          setDetail2(!detail2)*/}
        {/*        }}*/}
        {/*    />:null*/}
        {/*  }*/}
        {/*  <img*/}
        {/*      className="dian-sparkle"*/}
        {/*      style={{position: 'absolute', right: 0, top: 60}}*/}
        {/*      alt="Img"*/}
        {/*      src="/img/2026/dian.png"*/}
        {/*      onClick={() => {*/}
        {/*        setDetail2(!detail2)*/}
        {/*      }}*/}
        {/*  />*/}
        {/*</div>*/}


      </div>
    </div>
  );
};


export default Moment;
